import { useEffect, useState, useRef } from 'react';
import { processText } from 'core/utils/string';

export const useTimer = (pause, seconds = 60, onComplete = () => {}) => {
  const [wasPressed, setWasPressed] = useState(false);
  const [timer, setTimer] = useState(0);
  useEffect(() => {
    if (!pause) {
      var interval = setInterval(() => {
        setTimer((t) => t + 1);
      }, 1000);
    }
    if (pause) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [pause]);
  // When start timer reaches 100
  const increments = (timer * 100) / seconds;
  if (!wasPressed && timer === seconds) {
    setTimeout(() => {
      setWasPressed(true);
      onComplete();
    }, 100);
  }
  return increments;
};

export const useTextFlow = (
  pause,
  changePoints,
  variables = {},
  onComplete = () => {}
) => {
  const [wasPressed, setWasPressed] = useState(false);
  const [timer, setTimer] = useState(0);
  const [index, setIndex] = useState(0);
  if (!wasPressed && index === changePoints?.length) {
    setWasPressed(true);
    onComplete();
  }
  const { seconds, text } = changePoints?.[index] || {};
  const [processedText, setProcessedText] = useState(
    processText(text, variables)
  );
  useEffect(() => {
    if (processedText) {
      if (!pause) {
        var interval = setInterval(() => {
          setTimer((t) => t + 1);
        }, 1000);
      }
      if (pause) {
        clearInterval(interval);
      }
    } else {
      // TODO: Fix this timer... won't seem to clear
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [pause, processedText]);

  if (seconds === timer) {
    setTimer(0);
    setProcessedText(processText(changePoints?.[index + 1]?.text, variables));
    setIndex((i) => ++i);
  }
  return processedText;
};

// taken from https://joshwcomeau.com/snippets/react-hooks/use-interval
export function useInterval(callback, delay) {
  const intervalId = useRef(null);
  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  });
  useEffect(() => {
    const tick = () => savedCallback.current();
    if (typeof delay === 'number') {
      intervalId.current = window.setInterval(tick, delay);
      return () => window.clearInterval(intervalId.current);
    }
  }, [delay]);
  return intervalId.current;
}

/**
 * Below is probably dead code, but saving it just in case
 * This is depedent on with flavor.content and flavor.introText
 * **/
export const useIntroWithTimer = ({
  introRound,
  onComplete,
  pause,
  flavor,
}) => {
  const introTime = flavor.introText.reduce(
    (time, { seconds }) => seconds + time,
    0
  );
  const timer = introRound ? flavor.timer + introTime : flavor.timer;
  const percent = useTimer(pause, timer, onComplete);
  const introText = useTextFlow(pause, flavor.introText);
  const text = introRound
    ? introText || processText(flavor.content)
    : processText(flavor.content);
  return [percent, text];
};
